<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    :can-cancel="false"
    aria-role="dialog"
    aria-modal class="has-overflow">
      <div class="modal-card" style="width: auto">
        <ValidationObserver ref="observer">
          <header class="modal-card-head">
              <p class="modal-card-title">Nuevo día de herraje</p>
          </header>
          <section class="modal-card-body">
              <ValidationProvider
                name="Grupo"
                :rules="'required'"
                v-slot="{ errors }">
                <b-field label="Grupo"
                :type="{ 'is-danger': errors[0] }"
                :message="errors">
                  <b-select placeholder="Selecciona un grupo" v-model="group" expanded>
                      <option
                          v-for="option in selectablesGroups"
                          :value="option.id"
                          :key="option.id">
                          {{ option.title }}
                      </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            <b-field expanded>
              <ValidationProvider
                name="Fecha"
                :rules="'required'"
                v-slot="{ errors }">
                <b-field label="Fecha"
                :type="{ 'is-danger': errors[0] }"
                :message="errors">
                  <b-datepicker
                        placeholder="Selecciona un día"
                        v-model="date"
                        :first-day-of-week="1"
                        :month-names="$moment.months()"
                        :day-names="$moment.weekdaysShort()"
                        :unselectable-days-of-week="[0]"
                        :mobile-native="false"
                        :focused-date="firstDay"
                        :min-date="startDate"
                        :max-date="endDate"
                        indicators="bars"
                        :events="selectedDays"
                        @input="selectDay"
                        expanded>
                        <button class="button is-danger"
                            @click="date = null">
                            <b-icon icon="close"></b-icon>
                            <span>Limpiar</span>
                        </button>
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="isActiveModal = false">Cancelar</b-button>
            <b-button type="is-primary" @click="save" :loading="isLoading">Guardar</b-button>
          </footer>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
export default {
  components: {
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    },
    selectedDays: {
      type: Array,
      default: () => []
    },
    firstDay: {
      type: Date,
      default: () => new Date()
    },
    startDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    },
    dayEdit: {
      type: Object,
      default: null
    },
    selectedGroups: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isActiveModal: this.active,
      isLoading: false,
      date: null,
      group: null,
      groups: [
        { id: 1, title: 'Grupo 1' },
        { id: 2, title: 'Grupo 2' },
        { id: 3, title: 'Grupo 3' },
        { id: 4, title: 'Grupo 4' },
        { id: 5, title: 'Grupo 5' },
        { id: 6, title: 'Grupo 6' }
      ]
    }
  },
  methods: {
    selectDay (date) {
      if (date) {
        let disableDay = this.disableDays.find((x) => {
          return this.$moment(x).isSame(date)
        })
        if (disableDay) {
          this.openAlertDisabledDay()
        }
      }
    },
    openAlertDisabledDay () {
      this.$buefy.dialog.alert({
        message: '¡El día ya se encuentra seleccionado!',
        onConfirm: () => {
          this.date = null
        }
      })
    },
    async save () {
      if (await this.$refs.observer.validate()) {
        this.isLoading = true
        this.$emit('confirm', {
          date: this.date,
          group: this.group
        })
        this.date = null
        this.isLoading = false
        this.isActiveModal = false
      }
    }
  },
  watch: {
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
      }
    },
    dayEdit (value) {
      if (value) {
        this.date = value.date
      }
    }
  },
  computed: {
    disableDays () {
      return this.selectedDays.map((x) => x.date)
    },
    selectablesGroups () {
      console.log(this.selectedGroups)
      return this.groups.filter((x) => {
        let index = this.selectedGroups.findIndex((y) => y === x.id)
        return index === -1
      })
    }
  }
}
</script>
